import './CSVModal.scss';
export class CSVModalController {
    static $inject = ['close'];
    constructor(close) {
        this.close = close;
    }
    async sendCSV() {
        this.close(this.email);
    }
}
CSVModalController.$inject = ['close'];
